export interface AccountDeletionRequestRecord {
  id: number;
  userId: number;
  username: string;
  status: string;
  createTime?: string | number;
  updateTime?: string | number;
  alreadySubmitted?: boolean;
}

export interface AccountDeletionRequestResponse {
  success: boolean;
  message?: string;
  code?: string;
  data?: AccountDeletionRequestRecord;
}

const ACCOUNT_DELETION_REQUEST_ENDPOINT = '/api/img-cloud/account-deletion-requests';

/**
 * Submit an account deletion request for the authenticated img-cloud user.
 */
export const submitAccountDeletionRequest = async (): Promise<AccountDeletionRequestResponse> => {
  const response = await fetch(ACCOUNT_DELETION_REQUEST_ENDPOINT, {
    method: 'POST',
    credentials: 'same-origin',
  });
  const result = await response.json() as AccountDeletionRequestResponse;
  if (!response.ok || result.success === false) {
    throw new Error(result.message || 'Failed to submit account deletion request');
  }
  return result;
};
